import { FieldControllerProps } from '@dreryk/react-common';
import { ClassNameProp, TextInput } from '@dreryk/react-components';

import { healthcareOrganizationTranslationKeys } from '../../../../../../translations';

type UnitCodeInputProps = FieldControllerProps<'unitCode', string | null> & ClassNameProp;

const UNIT_CODE_MIN_LENGTH = 2;
const UNIT_CODE_MAX_LENGTH = 3;
const UNIT_CODE_REGEXP = /^(?!00)[1-9]?\d{2}$/u;

export const UnitCodeInput = (props: UnitCodeInputProps): JSX.Element => {
   const controller = props.register(props.name, {
      required: props.required,
      minLength: UNIT_CODE_MIN_LENGTH,
      maxLength: UNIT_CODE_MAX_LENGTH,
      pattern: {
         value: UNIT_CODE_REGEXP,
         message: healthcareOrganizationTranslationKeys.unitCodeValidationMessage,
      },
   });

   return (
      <TextInput
         testId={props.name}
         label={healthcareOrganizationTranslationKeys.resortCode.five}
         controller={controller}
         defaultValue={props.defaultValue}
         className={props.className}
      />
   );
};
